(() => {
  const q = (rot, sel) => (rot || document).querySelector(sel);
  const qa = (rot, sel) => Array.from((rot || document).querySelectorAll(sel));
  const num = (v, fallback = 0) => {
    const n = typeof v === "number" ? v : Number.parseFloat(String(v ?? "").replace(",", "."));
    return Number.isFinite(n) ? n : fallback;
  };
  const clamp = (v, min, max) => Math.min(max, Math.max(min, v));
  const motion = Object.freeze({
    duration: 0.32,
    ease: "power3.out",
    cssEase: "cubic-bezier(0.22, 1, 0.36, 1)"
  });
  const rafThrottle = (fn) => {
    let raf = 0, senast;
    return (...args) => {
      senast = args;
      if (raf) return;
      raf = requestAnimationFrame(() => (raf = 0, fn(...(senast || []))));
    };
  };
  const initLenisOmFinns = ({ wrapper, content } = {}) => {
    const Lenis = window.Lenis;
    if (!Lenis) return null;
    try {
      const lenis = new Lenis({ wrapper, content, smoothWheel: true, syncTouch: true });
      const tick = (t) => (lenis.raf(t), requestAnimationFrame(tick));
      requestAnimationFrame(tick);
      return lenis;
    } catch {
      return null;
    }
  };
  const prefersReducedMotion = () => !!(window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches);

  const scroll = Object.freeze({
    directions: Object.freeze({
      idle:     "idle",
      down:     "down",
      up:       "up"
    }),
    velocity: Object.freeze({
      still:    "still",    // ~0
      slow:     "slow",     // < 0.3
      medium:   "medium",   // 0.3 – 1.5
      fast:     "fast"      // > 1.5
    }),
    progress: Object.freeze({
      top:      "top",      // scrollY < 1 row-height
      middle:   "middle",   // between top and bottom
      bottom:   "bottom"    // within 1 row-height of end
    }),
    thresholds: Object.freeze({
      velocitySlow:   0.3,
      velocityFast:   1.5,
      atTopPx:        40,   // ~1 row-height, updated at runtime
      atBottomPx:     40
    })
  });

  const y2kIkoner = Object.freeze([
    "ring", "siluett", "ansikte", "kollage", "kors", "stjarna", "blomma", "mask", "blixt", "sol",
    "fjaril", "stjarnkors", "romb", "snurra", "triangel", "diamant", "leende", "kugghjul", "hjarta", "hjarta-ifylld"
  ]);

  window.VIVCER = Object.freeze({ q, qa, num, clamp, motion, rafThrottle, initLenisOmFinns, prefersReducedMotion, scroll, y2kIkoner });
})();
